import { ReactNode } from "react";
import styled, { css } from "styled-components";

interface SaveBarProps {
  hasUnsavedChanges?: boolean;
  unsavedChangesText: string;
  children: ReactNode;
}

const SaveBarContainer = styled.div<{ hasUnsavedChanges?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ theme }) => theme.space[4]};
  margin-bottom: ${({ theme }) => theme.space[5]};
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[3]}`};
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-inline-end: 20%;
    margin-inline-start: 20%;
  }

  ${(props) =>
    props.hasUnsavedChanges &&
    css`
      margin-inline-end: 1rem;
      margin-inline-start: 1rem;
      border-radius: 6px;
      background-color: ${(props) => props.theme.colors.purple1};

      @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
        margin-inline-end: 10%;
        margin-inline-start: 10%;
      }
    `}
`;

const UnsavedChangesText = styled.div`
  padding-inline-end: ${(props) => props.theme.space[2]};
  font-family: ${(props) => props.theme.fonts.base};
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
`;

const ButtonContainer = styled.div`
  width: 60%;
`;

const SaveBar = ({
  hasUnsavedChanges = false,
  unsavedChangesText,
  children,
}: SaveBarProps) => {
  return (
    <SaveBarContainer hasUnsavedChanges={hasUnsavedChanges}>
      {hasUnsavedChanges ? (
        <>
          <UnsavedChangesText>{unsavedChangesText}</UnsavedChangesText>
          <ButtonContainer>{children}</ButtonContainer>
        </>
      ) : (
        children
      )}
    </SaveBarContainer>
  );
};

export default SaveBar;
